export const statsData = [
  { id: 1, value: 15, suffix: '+', label: 'Games Released' },
  { id: 2, value: 2, suffix: 'M+', label: 'Players Worldwide' },
  { id: 3, value: 50, suffix: '+', label: 'Team Members' },
  { id: 4, value: 7, suffix: '', label: 'Platforms' },
  { id: 5, value: 50, suffix: '+', label: 'Countries' },
  { id: 6, value: 4.7, suffix: '★', label: 'Avg Rating' },
];

export const partnersData = [
  { id: 1, name: 'Microsoft', logo: '/images/partners/microsoft.png' },
  { id: 2, name: 'Unity', logo: '/images/partners/unity.png' },
  { id: 3, name: 'Unreal Engine', logo: '/images/partners/unreal.png' },
  { id: 4, name: 'PlayStation', logo: '/images/partners/playstation.png' },
  { id: 5, name: 'Xbox', logo: '/images/partners/xbox.png' },
  { id: 6, name: 'Nintendo', logo: '/images/partners/nintendo.png' },
  { id: 7, name: 'Epic Games', logo: '/images/partners/epic.png' },
  { id: 8, name: 'Steam', logo: '/images/partners/steam.png' },
];

export const awardsData = [
  {
    id: 1,
    title: 'Best African Game',
    event: 'Africa Game Developers Awards',
    year: '2024',
    game: 'Spirit Caller',
  },
  {
    id: 2,
    title: 'Innovation in Cultural Representation',
    event: 'Global Game Awards',
    year: '2024',
    game: 'Swahili Legends',
  },
  {
    id: 3,
    title: 'Best Mobile Game',
    event: 'East Africa Tech Awards',
    year: '2023',
    game: 'Maasai Runners',
  },
];

export const socialLinks = {
  twitter: 'https://twitter.com/rivenbyte',
  instagram: 'https://instagram.com/rivenbyte',
  discord: 'https://discord.gg/rivenbyte',
  youtube: 'https://youtube.com/@rivenbyte',
  linkedin: 'https://linkedin.com/company/rivenbyte',
  tiktok: 'https://tiktok.com/@rivenbyte',
};

export const companyInfo = {
  name: 'Riven Byte Studios',
  tagline: 'Crafting legendary African gaming experiences',
  founded: 2024,
  location: 'Dar es Salaam, Tanzania',
  email: 'hello@rivenbyte.com',
  phone: '+255 627 857 470',
  address: '123 Game Street, Masaki, Dar es Salaam, Tanzania',
};

export const navigationLinks = [
  { name: 'Home', path: '/' },
  { name: 'Games', path: '/games' },
  { name: 'About', path: '/about' },
  { name: 'Platforms', path: '/platforms' },
  { name: 'Team', path: '/team' },
  { name: 'Contact', path: '/contact' },
  { name: 'Privacy', path: '/legal' },
];

export const footerLinks = {
  quickLinks: [
    { name: 'Home', path: '/' },
    { name: 'Games', path: '/games' },
    { name: 'About', path: '/about' },
    { name: 'Team', path: '/team' },
    { name: 'Contact', path: '/contact' },
  ],
  platforms: [
    { name: 'All Platforms', path: '/platforms' },
    { name: 'PC Games', path: '/games?platform=pc' },
    { name: 'Android', path: '/games?platform=android' },
    { name: 'iOS', path: '/games?platform=ios' },
    { name: 'Console', path: '/games?platform=playstation' },
    { name: 'Browser', path: '/games?platform=html5' },
  ],
  legal: [
    { name: 'Legal & Privacy', path: '/legal' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Service', path: '/terms' },
    { name: 'Cookie Policy', path: '/cookies' },
  ],
};
